// extracted by mini-css-extract-plugin
module.exports = {"label":"form-label_label_4meLz"};